export const translations = {
    en: {
        "Dashboard": "Dashboard",
        "Bot Settings": "Bot Settings",
        "Account Details": "Account Details",
        "Account Settings": "Account Settings",
        "PLUGINS": "PLUGINS",
        "ACTIVE PLUGINS": "ACTIVE PLUGINS",
        "Saldırı Eklentileri": "Attack Plugins",
        "Üretim / Alet / Asker": "Production / Tools / Troops",
        "Save Changes": "Save Changes",
        "Saved!": "Saved!",
        "No Changes": "No Changes",
        "Loading settings...": "Loading settings...",
        "Username": "Username",
        "Password": "Password",
        "Server": "Server",
        "External Event (OR/BTH)": "External Event (OR/BTH)",
        "ENABLED": "ENABLED",
        "DISABLED": "DISABLED",
        "Logs": "Logs",
        "Settings": "Settings",
        "Start": "Start",
        "Stop": "Stop",
        "Remove": "Remove",
        "Logout": "Logout",
        "Aqua": "Aqua",
        "Level": "Level",
        "Mead": "Mead",
        "Food": "Food",
        "Coin": "Coin",
        "Rubies": "Rubies",
        "Hits": "Hits",
        "Barons": "Barons",
        "Name": "Name",
        "Description": "Description",
        "Plugins": "Plugins",
        "Status": "Status",
        "Actions": "Actions",
        "Bot Durumu": "Bot Status",
        "Select language": "Select Language",
        "Successfully saved": "Changes saved successfully!",
        // Castle Setup
        "Kale Bağlantısı": "Castle Connection",
        "Bu işlem tek seferlik! Kale atandıktan sonra değiştirilemez.": "This is a one-time operation! Castle cannot be changed after assignment.",
        "Sunucu": "Server",
        "Oyun Kullanıcı Adı": "Game Username",
        "Oyun Şifresi": "Game Password",
        "Kaydet ve Kilitle": "Save and Lock",
        "Doğrulanıyor...": "Verifying...",
        "Kullanıcı adı değiştirilemez": "Username cannot be changed",
        "Oyun şifrenizi değiştirdiyseniz buradan güncelleyin": "Update here if you changed your game password",
        // Plugin Names
        "Baron Saldırısı (İmparatorluk)": "Baron Saldırısı (İmparatorluk)",
        "Baron Saldırısı (Ateş)": "Baron Saldırısı (Ateş)",
        "Baron Saldırısı (Buz)": "Baron Saldırısı (Buz)",
        "Baron Saldırısı (Kumlar)": "Baron Saldırısı (Kumlar)",
        "Berimond Saldırısı": "Berimond Saldırısı",
        "Attack Fortress (Fire Peaks)": "Attack Fortress (Fire Peaks)",
        "Attack Fortress (Everwinter Glacier)": "Attack Fortress (Everwinter Glacier)",
        "Attack Fortress (Burning Sands)": "Attack Fortress (Burning Sands)",
        "Kale Saldırısı (Ateş Dorukları)": "Kale Saldırısı (Ateş Dorukları)",
        "Kale Saldırısı (Sonsuz Kış Buzulu)": "Kale Saldırısı (Sonsuz Kış Buzulu)",
        "Kale Saldırısı (Yanık Kumlar)": "Kale Saldırısı (Yanık Kumlar)",
        "Attack Nomad Camps": "Attack Nomad Camps",
        "Attack Samurai Camps": "Attack Samurai Camps",
        "Attack Beri Camps": "Attack Beri Camps",
        "Attack Khan": "Attack Khan",
        "Attack Aqua Forts": "Attack Aqua Forts",
        "Hits Barrons": "Hits Barrons",
        "Attack": "General Attack Settings",
        "Handles Hits": "Handles Hits",
        "commander": "Commander",
        "Commander": "Commander",
        "Feast": "Feast",
        "GetRegion": "Get Regions",
        "Mead replace": "Mead Repair",
        "MeadRep": "Mead Repair",
        "Timer": "Timer",
        "Smart Support": "Smart Support",
        "Feast Manager": "Feast Manager",
        "Mead Representative": "Mead Representative",
        "Support Manager": "Support Manager",
        "Timer Manager": "Timer Manager",
        "attack": "General Attack",
        "berikingdom": "Berimond Kingdom",
        "attackbarronsempire": "Empire Baron Attack",
        "attackbarronsfire": "Fire Baron Attack",
        "attackbarronsglacier": "Glacier Baron Attack",
        "attackbarronssands": "Sand Baron Attack",
        "attackberi": "Beri Tower Attack",
        "attackfortresses": "Fortress Attack",
        "attackfortresses_glacier": "Glacier Fortress Attack",
        "attackfortresses_sand": "Sand Fortress Attack",
        "attackforts": "Tower Attack",
        "attackkhan": "Khan Attack",
        "attacknomads": "Nomad Attack",
        "gocebeDanisman": "Nomad Advisor",
        "attacksams": "Samurai Attack",
        "autoRecruit": "AutoRecruit",
        "Auto recruits units and requests alliance help.": "Auto recruits units and requests alliance help.",
        "Unit ID (SK)": "Unit ID (SK)",
        "Default Amount": "Default Amount",
        "Barracks Type IDs": "Barracks Type IDs",
        // Descriptions
        "Hits fortresses": "Hits NPC fortresses automatically",
        "Hits Aqua Forts": "Hits Aqua forts automatically",
        "Hits Nomad Camps": "Hits Nomad camps automatically",
        "Hits Samurai Camps": "Hits Samurai camps automatically",
        "Hits Beri Camps": "Hits Beri camps automatically",
        "Hits Khan Camps": "Hits Khan camps automatically",
        "Sends Resources": "Sends resources between castles automatically",
        "Repair for Mead": "Repairs using Mead automatically",
        "Automatic feast management": "Manages feasts automatically",
        "Manage mead production and consumption": "Manages mead production and consumption",

        // Plugin Options & Difficulties
        "Easy": "Easy", "Easy+": "Easy+", "Intermediate": "Intermediate", "Intermediate+": "Intermediate+",
        "Hard": "Hard", "Hard+": "Hard+", "Expert": "Expert", "Expert+": "Expert+",
        "Master": "Master", "Master+": "Master+", "Archmaster": "Archmaster",
        "Event Difficulty": "Event Difficulty", "Com White List": "Com White List", "Use Coin": "Use Coin", "No chests": "No chests",
        "Use Time Skips": "Use Time Skips", "Skip Strategy": "Skip Strategy",
        "Smallest First (Save Big Skips)": "Smallest First (Save Big Skips)", "Best Fit (Fastest)": "Best Fit (Fastest)",
        "Nomad score shutoff": "Nomad score shutoff", "Samurai score shutoff": "Samurai score shutoff",
        "Lowest value chests first": "Lowest value chests first", "Use event Wall Tools first": "Use event Wall Tools first",
        "Smart Unit Replacement": "Smart Unit Replacement", "Auto Transfer Troops (Every 15m)": "Auto Transfer Troops (Every 15m)",
        "Use Feather (Travel Boost)": "Use Feather (Travel Boost)", "Attack Plan JSON": "Attack Plan JSON",
        "Use Game Preset": "Use Game Preset", "Preset ID (Slot Number)": "Preset ID (Slot Number)",
        "Max Waves": "Max Waves", "1 Wave": "1 Wave", "2 Waves": "2 Waves", "3 Waves": "3 Waves", "4 Waves": "4 Waves",
        "Attack Delay (Seconds)": "Attack Delay (Seconds)", "Attack Delay Randomization (Seconds)": "Attack Delay Randomization (Seconds)",
        "Attack Left Flank": "Attack Left Flank", "Attack Middle": "Attack Middle", "Attack Right Flank": "Attack Right Flank",
        "Attack Courtyard": "Attack Courtyard", "Easy forts only": "Easy forts only", "Add worser forts": "Add worser forts",
        "Buy Coins": "Buy Coins", "Buy Deco": "Buy Deco", "Reputation mode": "Reputation mode", "No event tools": "No event tools",
        "Use Feather": "Use Feather", "Use Coin (Gold Horse)": "Use Coin (Gold Horse)",
        "Max Waves (1-4)": "Max Waves (1-4)", "Waves till chest": "Waves till chest",
        // Labels
        "Horse Settings": "Horse Settings", "Attack Settings": "Attack Settings", "Event Settings": "Event Settings",
        "Tool/Chest Settings": "Tool/Chest Settings",
        // New translations for UI
        "Add Castle": "Add Castle",
        "Game Castles": "Game Castles",
        "Remove Selected": "Remove Selected",
        "Link New Game Account": "Link New Game Account",
        "Game Username": "Game Username",
        "Game Password": "Game Password",
        "Failed to add castle": "Failed to add castle",
        "Please fill all fields": "Please fill all fields",
        "Network error": "Network error",
        "Cancel": "Cancel",
        "Add": "Add",
        "Clear Logs": "Clear Logs",
        "SALDIRI AYARLARI": "ATTACK SETTINGS",
        "Saldiri gecikme, limit ve flank ayarlari": "Attack delay, limit and flank settings",
        "Gunluk Saldiri Sayaci": "Daily Attack Counter",
        "Sifirlama: Her gun 01:00 (Turkiye saati)": "Reset: Every day 01:00 (Turkey time)",
        "Saldiri Limiti": "Attack Limit",
        "Hedef saldiri limiti aktif": "Target attack limit enabled",
        "Hedef saldiri sayisi": "Target attack count",
        "Abonelik": "Subscription",
        "gun kaldi": "days remaining",
        "Aboneliginiz sona erdi!": "Your subscription has expired!",
        "Gunlukler": "Logs",
        "Sistem Gunlukleri": "System Logs"
    },
    tr: {
        "Dashboard": "Kontrol Paneli",
        "Bot Settings": "Bot Ayarları",
        "Account Details": "Hesap Detayları",
        "Account Settings": "Hesap Ayarları",
        "PLUGINS": "EKLENTİLER",
        "ACTIVE PLUGINS": "AKTİF EKLENTİLER",
        "Saldırı Eklentileri": "Saldırı Eklentileri",
        "Üretim / Alet / Asker": "Üretim / Alet / Asker",
        "Save Changes": "Değişiklikleri Kaydet",
        "Saved!": "Kaydedildi!",
        "No Changes": "Değişiklik Yok",
        "Loading settings...": "Ayarlar yükleniyor...",
        "Username": "Kullanıcı Adı",
        "Password": "Şifre",
        "Server": "Sunucu",
        "External Event (OR/BTH)": "Dış Etkinlik (OR/BTH)",
        "ENABLED": "AKTİF",
        "DISABLED": "PASİF",
        "Logs": "Günlükler",
        "Settings": "Ayarlar",
        "Start": "Başlat",
        "Stop": "Durdur",
        "Remove": "Sil",
        "Logout": "Çıkış Yap",
        "Aqua": "Akuamarin",
        "Level": "Seviye",
        "Mead": "Mey",
        "Food": "Yiyecek",
        "Coin": "Altın",
        "Rubies": "Yakut",
        "Hits": "Vuruşlar",
        "Barons": "Baronlar",
        "Name": "İsim",
        "Description": "Açıklama",
        "Plugins": "Eklentiler",
        "Status": "Durum",
        "Actions": "İşlemler",
        "Bot Durumu": "Bot Durumu",
        "Select language": "Dil Seçin",
        "Successfully saved": "Değişiklikler başarıyla kaydedildi!",
        // Castle Setup
        "Kale Bağlantısı": "Kale Bağlantısı",
        "Bu işlem tek seferlik! Kale atandıktan sonra değiştirilemez.": "Bu işlem tek seferlik! Kale atandıktan sonra değiştirilemez.",
        "Sunucu": "Sunucu",
        "Oyun Kullanıcı Adı": "Oyun Kullanıcı Adı",
        "Oyun Şifresi": "Oyun Şifresi",
        "Kaydet ve Kilitle": "Kaydet ve Kilitle",
        "Doğrulanıyor...": "Doğrulanıyor...",
        "Kullanıcı adı değiştirilemez": "Kullanıcı adı değiştirilemez",
        "Oyun şifrenizi değiştirdiyseniz buradan güncelleyin": "Oyun şifrenizi değiştirdiyseniz buradan güncelleyin",
        // Plugin Names
        "Baron Saldırısı (İmparatorluk)": "Baron Saldırısı (İmparatorluk)",
        "Baron Saldırısı (Ateş)": "Baron Saldırısı (Ateş)",
        "Baron Saldırısı (Buz)": "Baron Saldırısı (Buz)",
        "Baron Saldırısı (Kumlar)": "Baron Saldırısı (Kumlar)",
        "Berimond Saldırısı": "Berimond Saldırısı",
        "Attack Fortress (Fire Peaks)": "Kale Saldırısı (Ateş Dorukları)",
        "Attack Fortress (Everwinter Glacier)": "Kale Saldırısı (Sonsuz Kış Buzulu)",
        "Attack Fortress (Burning Sands)": "Kale Saldırısı (Yanık Kumlar)",
        "Kale Saldırısı (Ateş Dorukları)": "Kale Saldırısı (Ateş Dorukları)",
        "Kale Saldırısı (Sonsuz Kış Buzulu)": "Kale Saldırısı (Sonsuz Kış Buzulu)",
        "Kale Saldırısı (Yanık Kumlar)": "Kale Saldırısı (Yanık Kumlar)",
        "Attack Nomad Camps": "Göçebe Kampı Saldırısı",
        "Attack Samurai Camps": "Samuray Kampı Saldırısı",
        "Attack Beri Camps": "Beri Kampı Saldırısı",
        "Attack Khan": "Han Saldırısı",
        "Attack Aqua Forts": "Ada Saldırısı",
        "Hits Barrons": "Baron Vuruşları",
        "Attack": "Genel Saldırı Ayarları",
        "Handles Hits": "Vuruşları Yönetir",
        "commander": "Komutan",
        "Commander": "Komutan",
        "Feast": "Ziyafet",
        "GetRegion": "Bölgeleri Topla",
        "Mead replace": "Bal Şarabı/Onarım",
        "MeadRep": "Bal Şarabı/Onarım",
        "Timer": "Zamanlayıcı",
        "Smart Support": "Akıllı Destek",
        "Feast Manager": "Şölen Yöneticisi",
        "Mead Representative": "Mey Temsilcisi",
        "Support Manager": "Destek Yöneticisi",
        "Timer Manager": "Zamanlayıcı Yöneticisi",
        "attack": "Genel Saldırı",
        "berikingdom": "Berimond Krallığı",
        "attackbarronsempire": "İmparatorluk Baron Saldırısı",
        "attackbarronsfire": "Ateş Baron Saldırısı",
        "attackbarronsglacier": "Buz Baron Saldırısı",
        "attackbarronssands": "Kum Baron Saldırısı",
        "attackberi": "Berimond Kule Saldırısı",
        "attackfortresses": "Kale Saldırısı",
        "attackfortresses_glacier": "Buz Kalesi Saldırısı",
        "attackfortresses_sand": "Kum Kalesi Saldırısı",
        "attackforts": "Kule Saldırısı",
        "attackkhan": "Han Saldırısı",
        "attacknomads": "Göçebe Saldırısı",
        "gocebeDanisman": "Göçebe Danışman",
        "attacksams": "Samuray Saldırısı",
        "autoRecruit": "Otomatik Asker Basma",
        "Auto recruits units and requests alliance help.": "Otomatik asker basar ve ittifak yardımı ister.",
        "Unit ID (SK)": "Asker ID (SK)",
        "Default Amount": "Varsayılan Miktar",
        "Barracks Type IDs": "Kışla Bina ID'leri",
        // Descriptions
        "Hits fortresses": "NPC kalelerine otomatik saldırır",
        "Hits Aqua Forts": "Su kalelerine otomatik saldırır",
        "Hits Nomad Camps": "Göçebe kamplarına otomatik saldırır",
        "Hits Samurai Camps": "Samuray kamplarına otomatik saldırır",
        "Hits Beri Camps": "Beri kamplarına otomatik saldırır",
        "Hits Khan Camps": "Han kamplarına otomatik saldırır",
        "Sends Resources": "Kaleler arası otomatik kaynak gönderir",
        "Repair for Mead": "Bal şarabı ile otomatik onarım yapar",
        "Automatic feast management": "Şölenleri otomatik yönetir",
        "Manage mead production and consumption": "Mey üretim ve tüketimini yönetir",

        // Eklenti Ayarları ve Zorluklar
        "Easy": "Kolay", "Easy+": "Kolay+", "Intermediate": "Orta", "Intermediate+": "Orta+",
        "Hard": "Zor", "Hard+": "Zor+", "Expert": "Uzman", "Expert+": "Uzman+",
        "Master": "Usta", "Master+": "Usta+", "Archmaster": "Büyük Usta",
        "Event Difficulty": "Etkinlik Zorluğu", "Com White List": "Komutan Listesi (ID)", "Use Coin": "Altın Kullan", "No chests": "Sandık Toplama",
        "Use Time Skips": "Süregeç Kullan", "Skip Strategy": "Atlama Stratejisi",
        "Smallest First (Save Big Skips)": "En Küçük Önce (Büyükleri Sakla)", "Best Fit (Fastest)": "En Uygun (En Hızlı)",
        "Nomad score shutoff": "Göçebe Puan Limiti (Durdur)", "Samurai score shutoff": "Samuray Puan Limiti (Durdur)",
        "Lowest value chests first": "Düşük Değerli Sandıklar Önce", "Use event Wall Tools first": "Etkinlik Aletlerini Kullan",
        "Smart Unit Replacement": "Akıllı Asker Değişimi", "Auto Transfer Troops (Every 15m)": "Otomatik Asker Transferi (15dk)",
        "Use Feather (Travel Boost)": "Tüy Kullan (Hız)", "Attack Plan JSON": "Saldırı Planı (JSON)",
        "Use Game Preset": "Oyun Önayarını Kullan", "Preset ID (Slot Number)": "Önayar Slot ID",
        "Max Waves": "Maksimum Dalga", "1 Wave": "1 Dalga", "2 Waves": "2 Dalga", "3 Waves": "3 Dalga", "4 Waves": "4 Dalga",
        "Attack Delay (Seconds)": "Saldırı Gecikmesi (Saniye)", "Attack Delay Randomization (Seconds)": "Gecikme Rastgeleliği (Saniye)",
        "Attack Left Flank": "Sol Kanat", "Attack Middle": "Orta", "Attack Right Flank": "Sağ Kanat",
        "Attack Courtyard": "Avluya Saldır", "Easy forts only": "Sadece Kolay Adalar", "Add worser forts": "Daha Zayıf Adalar Ekle",
        "Buy Coins": "Altın Satın Al", "Buy Deco": "Dekorasyon Satın Al", "Reputation mode": "Prestij Modu", "No event tools": "Etkinlik Aleti Yok",
        "Use Feather": "Tüy Kullan", "Use Coin (Gold Horse)": "Altın Kullan (Turbo)",
        "Max Waves (1-4)": "Maks. Dalga (1-4)", "Waves till chest": "Sandık İçin Dalga",
        // Label'lar
        "Horse Settings": "At Ayarları", "Attack Settings": "Saldırı Ayarları", "Event Settings": "Etkinlik Ayarları",
        "Tool/Chest Settings": "Alet/Sandık Ayarları",
        // Yeni UI çevirileri
        "Add Castle": "Kale Ekle",
        "Game Castles": "Oyun Kaleleri",
        "Remove Selected": "Seçilenleri Sil",
        "Link New Game Account": "Yeni Oyun Hesabı Bağla",
        "Game Username": "Oyun Kullanıcı Adı",
        "Game Password": "Oyun Şifresi",
        "Failed to add castle": "Kale eklenemedi",
        "Please fill all fields": "Lütfen tüm alanları doldurun",
        "Network error": "Ağ hatası",
        "Cancel": "İptal",
        "Add": "Ekle",
        "Clear Logs": "Günlükleri Temizle",
        "SALDIRI AYARLARI": "SALDIRI AYARLARI",
        "Saldiri gecikme, limit ve flank ayarlari": "Saldırı gecikme, limit ve flank ayarları",
        "Gunluk Saldiri Sayaci": "Günlük Saldırı Sayacı",
        "Sifirlama: Her gun 01:00 (Turkiye saati)": "Sıfırlama: Her gün 01:00 (Türkiye saati)",
        "Saldiri Limiti": "Saldırı Limiti",
        "Hedef saldiri limiti aktif": "Hedef saldırı limiti aktif",
        "Hedef saldiri sayisi": "Hedef saldırı sayısı",
        "Gunlukler": "Günlükler",
        "Sistem Gunlukleri": "Sistem Günlükleri",
        "Abonelik": "Abonelik",
        "gun kaldi": "gün kaldı",
        "Aboneliginiz sona erdi!": "Aboneliğiniz sona erdi!"
    }
};

export const getTranslation = (lang, key) => {
    if (!translations[lang]) return key;
    return translations[lang][key] || key;
};
